import React, { useEffect, useState } from 'react';
import './ResetPasswordForm-styles.css';
import logo from '../../../../assets/images/logo.png';
import { BRAND_NAME } from '../../../../themeSetting';
import { ArrowRight, Smartphone } from 'lucide-react';
import { PhoneInputField } from '../../../profileInfo/components/Forms/GenericInputField/PhoneInputField';
import { Form, Formik } from 'formik';
import ResetPasswordFormvalidationSchema from './ResetPasswordFormvalidationSchema';
import { ROUTES } from '../../../profileInfo/constant/Routes';
import { conf } from '../../../../confg';
import axios from 'axios';
import useToast from '../../hook/useToast';
import { Redirect } from 'react-router-dom';
import { isAuthenticated } from '../../../../utils/isAuthenticated';
import { connect } from 'react-redux';
import { set_me } from '../../../../actions/user';
import { notNullAndUndefined } from '../../../../helper';

const ResetPasswordForm = ({ user, set_me }) => {
  const { toasts, showSuccessToast, showErrorToast, hideSuccessToast, hideErrorToast } = useToast();

  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    mobile: '',
  };

  const send_otp = (username) => {
    console.log(username);
    if (!username || username.trim() === '') {
      showErrorToast('شماره موبایل وارد نشده است');
      return;
    }
    setIsLoading(true);

    let otp_conf = {
      url: conf.server_url + 'auth/otp',
      method: 'POST',
      timeout: 0,
      mimeType: 'multipart/form-data',
      contentType: false,
      data: { username: username },
    };
    axios(otp_conf)
      .then((res) => {
        showSuccessToast(`کد به شماره ${username} ارسال شد `);
        window.location.href = `${ROUTES.OTP}?mobile=${username}&isForgetPassword=true`;
        setIsLoading(false);
      })
      .catch((error) => {
        console.log({ error });
        showErrorToast(error.response.data.message);
        setIsLoading(false);
      })
      .finally((r) => {
        setIsLoading(false);
      });
  };
  const handleSubmit = (data) => {
    console.log({ data });
    console.log(data.mobile);
    send_otp(data.mobile);
  };
  useEffect(() => {
    let tok = localStorage.getItem('token');
    if (notNullAndUndefined(tok)) {
      set_me();
    }
  }, []);

  if (Object.keys(user).length > 0) {
    return <Redirect to='/' />;
  }
  return (
    <div className='login-container-form'>
      <div className='login-card-form'>
        {/* Header */}
        <div className='login-header-form'>
          <div className='back-arrow'>
            <a href={ROUTES.SIGN_IN}>
              <ArrowRight size={24} />
            </a>
          </div>
        </div>

        {/* Logo */}
        <div className='login-content'>
          <div className='logo-container'>
            <div className='logo'>
              <a href='/'>
                <img
                  src={logo}
                  className='img-fluid'
                  style={{ width: '100px' }}
                  alt={BRAND_NAME}
                  onClick={() => {
                    this.setState({ home: true });
                  }}
                />
              </a>
            </div>
          </div>

          <h1 className='main-title'>تغییر رمز عبور</h1>

          <p className='subtitle'>برای تغییر رمز عبور, شماره موبایل خود را وارد کنید</p>
        </div>

        {/* Form */}
        <div className='form-container-login-form'>
          <div className='input-wrapper'>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={ResetPasswordFormvalidationSchema}
              onSubmit={handleSubmit}
              validate={(values) => {
                return {};
              }}
            >
              {({ errors, touched }) => {
                const allErrors = {
                  ...errors,
                };
                return (
                  <Form>
                    <PhoneInputField
                      hasLable={false}
                      name='mobile'
                      placeholder={'...۰۹'}
                      errors={allErrors}
                      touched={touched}
                      icon={<Smartphone size={18} style={{ backgroundColor: 'white' }} />}
                      iconPosition='left'
                    />
                    <button type='submit' className='submit-button-form-login'>
                      {isLoading ? 'در حال تایید ' : 'تایید'}
                    </button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};
const MapStateToProps = (state) => ({
  user: state.user,
});

export default connect(MapStateToProps, {
  set_me,
})(ResetPasswordForm);
